module.exports = __webpack_public_path__ + "img/img25.6ff82977.svg";